export default {
  'app.settings.menuMap.basic': '基本设置',
  'app.settings.menuMap.security': '安全设置',
  'app.settings.menuMap.binding': '账号绑定',
  'app.settings.menuMap.notification': '新消息通知',
  'app.settings.basic.avatar': '头像',
  'app.settings.basic.change-avatar': '更换头像',
  'app.settings.basic.email': '邮箱',
  'app.settings.basic.email-message': '请输入您的邮箱!',
  'app.settings.basic.nickname': '昵称',
  'app.settings.basic.nickname-message': '请输入您的昵称!',
  'app.settings.basic.profile': '个人简介',
  'app.settings.basic.profile-message': '请输入个人简介!',
  'app.settings.basic.profile-placeholder': '个人简介',
  'app.settings.basic.country': '国家/地区',
  'app.settings.basic.country-message': '请输入您的国家或地区!',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '请输入您的所在省市!',
  'app.settings.basic.address': '街道地址',
  'app.settings.basic.address-message': '请输入您的街道地址!',
  'app.settings.basic.phone': '联系电话',
  'app.settings.basic.phone-message': '请输入您的联系电话!',
  'app.settings.basic.update': '更新基本信息',
  'app.settings.security.strong': '强',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': '账户密码',
  'app.settings.security.password-description': '当前密码强度',
  'app.settings.security.phone': '密保手机',
  'app.settings.security.phone-description': '已绑定手机',
  'app.settings.security.question': '密保问题',
  'app.settings.security.question-description':
    '未设置密保问题，密保问题可有效保护账户安全',
  'app.settings.security.email': '备用邮箱',
  'app.settings.security.email-description': '已绑定邮箱',
  'app.settings.security.mfa': 'MFA 设备',
  'app.settings.security.mfa-description':
    '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'app.settings.security.modify': '修改',
  'app.settings.security.set': '设置',
  'app.settings.security.bind': '绑定',
  'app.settings.binding.taobao': '绑定淘宝',
  'app.settings.binding.taobao-description': '当前未绑定淘宝账号',
  'app.settings.binding.alipay': '绑定支付宝',
  'app.settings.binding.alipay-description': '当前未绑定支付宝账号',
  'app.settings.binding.dingding': '绑定钉钉',
  'app.settings.binding.dingding-description': '当前未绑定钉钉账号',
  'app.settings.binding.bind': '绑定',
  'app.settings.notification.password': '账户密码',
  'app.settings.notification.password-description':
    '其他用户的消息将以站内信的形式通知',
  'app.settings.notification.messages': '系统消息',
  'app.settings.notification.messages-description':
    '系统消息将以站内信的形式通知',
  'app.settings.notification.todo': '待办任务',
  'app.settings.notification.todo-description': '待办任务将以站内信的形式通知',
  'app.settings.open': '开',
  'app.settings.close': '关',
  'kg.settings.pageSubtitle':
    '统一管理平台图谱的默认行为、展示策略、抽取规则与治理阈值。',
  'kg.settings.navLabel': '设置分组',
  'kg.settings.pageEyebrow': '平台图谱设置中心',
  'kg.settings.noticeTitle': '更改会直接作用于平台级图谱配置',
  'kg.settings.noticeDescription':
    '建议按分组逐项保存。切换分组前若存在未保存修改，系统会提醒你继续编辑或放弃更改。',
  'kg.settings.lastUpdated': '最后更新',
  'kg.settings.sections.basic.title': '基础设置',
  'kg.settings.sections.basic.description':
    '配置默认视图、默认类型与默认查询范围。',
  'kg.settings.sections.basic.intro':
    '这组配置决定平台图谱设置页与图谱工作台的初始进入状态，影响管理员首次进入后的默认工作上下文。',
  'kg.settings.sections.display.title': '展示策略',
  'kg.settings.sections.display.description':
    '统一控制图谱画布的布局、密度与摘要显示方式。',
  'kg.settings.sections.display.intro':
    '展示策略用于稳定图谱浏览体验，避免不同管理员在查看同一张图谱时得到割裂的默认视觉反馈。',
  'kg.settings.sections.extraction.title': '抽取与审核',
  'kg.settings.sections.extraction.description':
    '管理 AI 抽取模型、阈值和审核门槛。',
  'kg.settings.sections.extraction.intro':
    '抽取规则决定导入后是否自动触发识别，以及哪些结果可以自动通过、哪些必须进入人工审核。',
  'kg.settings.sections.governance.title': '治理默认值',
  'kg.settings.sections.governance.description':
    '定义去重、导入和系统类型保护的默认规则。',
  'kg.settings.sections.governance.intro':
    '治理默认值会影响批量导入、实体去重和系统内置类型的可修改范围，建议由平台管理员统一维护。',
  'kg.settings.actions.restoreDefaults': '恢复平台默认配置',
  'kg.settings.actions.cancel': '取消',
  'kg.settings.actions.discard': '放弃更改',
  'kg.settings.actions.continueEditing': '继续编辑',
  'kg.settings.actions.resetSection': '重置当前分组',
  'kg.settings.actions.saveSection': '保存当前分组',
  'kg.settings.messages.loadFailed': '设置加载失败，请稍后重试',
  'kg.settings.messages.leaveTitle': '当前分组有未保存更改',
  'kg.settings.messages.leaveContent':
    '切换前需要决定是继续编辑，还是放弃当前分组中的未保存修改。',
  'kg.settings.messages.saveFailed': '设置保存失败，请稍后重试',
  'kg.settings.messages.resetTitle': '确认恢复平台默认配置？',
  'kg.settings.messages.resetContent':
    '恢复默认会覆盖当前所有分组的已保存配置，请确认这次重置不会影响现有运营策略。',
  'kg.settings.messages.resetSuccess': '平台图谱设置已恢复默认',
  'kg.settings.messages.resetFailed': '恢复默认失败，请稍后重试',
  'kg.settings.messages.basicSaved': '基础设置已保存',
  'kg.settings.messages.displaySaved': '展示策略已保存',
  'kg.settings.messages.extractionSaved': '抽取与审核设置已保存',
  'kg.settings.messages.governanceSaved': '治理默认值已保存',
  'kg.settings.fields.defaultViewName': '默认图谱视图名称',
  'kg.settings.fields.defaultSearchScope': '默认查询范围',
  'kg.settings.fields.defaultEntityType': '默认实体类型',
  'kg.settings.fields.defaultRelationType': '默认关系类型',
  'kg.settings.fields.autoExpandRelatedEntities': '自动展开关联实体',
  'kg.settings.fields.defaultLayout': '默认布局算法',
  'kg.settings.fields.nodeDensity': '节点密度模式',
  'kg.settings.fields.showRelationLabels': '显示关系标签',
  'kg.settings.fields.enableNodeAggregation': '启用节点聚合视图',
  'kg.settings.fields.showPropertySummary': '显示属性摘要面板',
  'kg.settings.fields.highlightPathOnHover': '悬浮时高亮路径',
  'kg.settings.fields.modelProvider': '默认抽取模型',
  'kg.settings.fields.promptStrategy': '提示词策略',
  'kg.settings.fields.confidenceThreshold': '抽取置信度阈值',
  'kg.settings.fields.autoApproveThreshold': '自动通过阈值',
  'kg.settings.fields.autoExtractOnImport': '导入后自动触发抽取',
  'kg.settings.fields.requireManualReview': '低于自动通过阈值时进入人工审核',
  'kg.settings.fields.enableRiskBlocking': '启用高风险拦截',
  'kg.settings.fields.deduplicationMode': '默认去重策略',
  'kg.settings.fields.defaultSourceStatus': '新数据默认状态',
  'kg.settings.fields.maxImportBatchSize': '单批导入上限',
  'kg.settings.fields.enableChangeAudit': '启用配置变更审计',
  'kg.settings.fields.lockSystemTypes': '锁定系统内置类型',
  'kg.settings.placeholders.defaultViewName': '例如：平台图谱总览',
  'kg.settings.placeholders.defaultEntityType': '请选择默认实体类型',
  'kg.settings.placeholders.defaultRelationType': '请选择默认关系类型',
  'kg.settings.validation.defaultViewName': '请输入默认图谱视图名称',
  'kg.settings.options.scope.platform': '平台范围',
  'kg.settings.options.scope.tenant': '租户范围',
  'kg.settings.options.layout.force': '力导布局',
  'kg.settings.options.layout.radial': '径向布局',
  'kg.settings.options.layout.dagre': '分层布局',
  'kg.settings.options.density.comfortable': '舒展',
  'kg.settings.options.density.balanced': '均衡',
  'kg.settings.options.density.compact': '紧凑',
  'kg.settings.options.prompt.balanced': '平衡',
  'kg.settings.options.prompt.strict': '严格',
  'kg.settings.options.prompt.aggressive': '激进',
  'kg.settings.options.deduplication.manual': '人工确认',
  'kg.settings.options.deduplication.semiAuto': '半自动合并',
  'kg.settings.options.deduplication.strict': '严格去重',
  'kg.settings.options.sourceStatus.draft': '草稿',
  'kg.settings.options.sourceStatus.active': '启用',
  'kg.settings.blocks.basic.title': '默认进入行为',
  'kg.settings.blocks.basic.description':
    '约束首次进入图谱工作区时的默认展开与查询上下文。',
  'kg.settings.blocks.display.title': '画布显示项',
  'kg.settings.blocks.display.description':
    '这些项会影响节点、关系和属性信息的默认可见性。',
  'kg.settings.blocks.extraction.title': '抽取执行策略',
  'kg.settings.blocks.extraction.description':
    '控制导入后是否自动识别，以及何时触发审核与风险拦截。',
  'kg.settings.blocks.governance.title': '治理执行策略',
  'kg.settings.blocks.governance.description':
    '统一管理去重、导入批次和系统内置能力的修改边界。',
  'kg.settings.help.autoExpandRelatedEntities':
    '开启后，进入实体详情或默认图谱视图时会优先展开一度关联节点。',
  'kg.settings.help.showRelationLabels':
    '关闭后，关系文本将默认折叠，仅在聚焦或选中时展示。',
  'kg.settings.help.enableNodeAggregation':
    '聚合相似节点，降低大规模图谱首屏渲染噪音。',
  'kg.settings.help.showPropertySummary':
    '在节点信息面板中默认展示关键属性摘要。',
  'kg.settings.help.highlightPathOnHover':
    '鼠标悬浮节点或关系时，自动高亮上下游路径。',
  'kg.settings.help.autoExtractOnImport':
    '导入任务完成后立即进入 AI 抽取流程，无需二次触发。',
  'kg.settings.help.requireManualReview':
    '未达到自动通过阈值的结果必须进入人工审核队列。',
  'kg.settings.help.enableRiskBlocking':
    '对高风险关系和敏感字段变更进行额外拦截。',
  'kg.settings.help.enableChangeAudit': '记录关键设置调整人、时间与修改内容。',
  'kg.settings.help.lockSystemTypes':
    '锁定后，系统预置实体类型和关系类型不能被随意改写。',
};
